import { AppError } from "@/lib/utils/errors";
import { locationService } from "@/modules/services/locationService";
import { useProvinceStore } from "@/modules/store/metadataStore";
import { Province } from "@/modules/types/metadata/metadata";
import { useEffect, useState } from "react";

export const useLocation = () => {
  const { provinces, setProvinces } = useProvinceStore();
  const [provincesState, setProvincesState] = useState<Province[]>([]);

  useEffect(() => {
    if (!provinces || provinces.length === 0) {
      fetchProvinces();
    } else {
      setProvincesState(provinces);
    }
  }, []);

  const fetchProvinces = async () => {
    try {
      const resp = await locationService.getProvinces();
      if (resp) {
        setProvinces(resp.provinces);
        setProvincesState(resp.provinces);
      }
    } catch (err) {
      const appErr = new AppError(err);
      appErr.logError();
    }
  };

  const searchProvinces = async (query: string) => {
    if (provinces) {
      const newProvices = provinces.filter((province) =>
        province.name.toLowerCase().includes(query.toLowerCase()),
      );
      setProvincesState(newProvices);
    } else {
      await fetchProvinces();
      const newProvices = provincesState.filter((province) =>
        province.name.toLowerCase().includes(query.toLowerCase()),
      );
      setProvincesState(newProvices);
    }
  };

  return {
    provinces: provincesState,
    fetchProvinces,
    searchProvinces,
  };
};
